(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-size-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('card-size-picker')) return;

    var LETTER_RANK = {
      'XXXXS': -1, 'XXXS': 0, 'XXS': 1, 'XS': 2, 'S': 3, 'M': 4,
      'L': 5, 'XL': 6, 'XXL': 7, 'XXXL': 8, 'XXXXL': 9, 'XXXXXL': 10
    };

    function sizeRank(raw, index) {
      var s = (raw == null ? '' : String(raw)).trim().toUpperCase().replace(/\s+/g, '');
      s = s.replace(/^(EUR|EU|US|UK|IL|FR|IT)/, '');
      var m = s.match(/^([2-5])X(S|L)$/);
      if (m) { s = new Array(parseInt(m[1], 10) + 1).join('X') + m[2]; }
      var m2 = s.match(/^([1-5])X$/);
      if (m2) { s = new Array(parseInt(m2[1], 10) + 1).join('X') + 'L'; }
      if (Object.prototype.hasOwnProperty.call(LETTER_RANK, s)) return { g: 0, v: LETTER_RANK[s] };
      var num = (raw == null ? '' : String(raw)).match(/-?\d+(\.\d+)?/);
      if (num) return { g: 1, v: parseFloat(num[0]) };
      return { g: 2, v: index };
    }

    function compareSizes(a, b) {
      var ra = sizeRank(a.label, a.index);
      var rb = sizeRank(b.label, b.index);
      if (ra.g !== rb.g) return ra.g - rb.g;
      if (ra.v !== rb.v) return ra.v - rb.v;
      return a.index - b.index;
    }

    class CardSizePicker extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.card-size-picker__list');
        this.live = this.querySelector('.card-size-picker__live');
        this.sizePos = parseInt(this.dataset.sizePos, 10);
        this.colorPos = this.dataset.colorPos ? parseInt(this.dataset.colorPos, 10) : null;
        this.defaultColor = this.dataset.defaultColor || '';
        this.card = this.closest('product-card');

        try {
          var dataEl = this.querySelector('.card-size-picker__data');
          this.variants = dataEl ? (JSON.parse(dataEl.textContent).variants || []) : [];
        } catch (e) {
          this.variants = [];
        }

        this.sortButtons();

        this._onClick = this.onClick.bind(this);
        if (this.list) this.list.addEventListener('click', this._onClick);

        if (this.card && this.colorPos) {
          this._onVariantUpdate = this.onVariantUpdate.bind(this);
          this._onSwatchChange = this.onSwatchChange.bind(this);
          this.card.addEventListener('variant:update', this._onVariantUpdate);
          this.card.addEventListener('change', this._onSwatchChange);
        }

        this.refresh(this.currentColor());
      }

      disconnectedCallback() {
        if (this.list) this.list.removeEventListener('click', this._onClick);
        if (this.card && this.colorPos) {
          this.card.removeEventListener('variant:update', this._onVariantUpdate);
          this.card.removeEventListener('change', this._onSwatchChange);
        }
      }

      sortButtons() {
        if (!this.list) return;
        var btns = Array.prototype.slice.call(this.list.querySelectorAll('.card-size-picker__btn'));
        if (btns.length < 2) return;
        var items = btns.map(function (el, i) { return { el: el, label: el.getAttribute('data-size'), index: i }; });
        items.sort(compareSizes);
        var list = this.list;
        items.forEach(function (item) { list.appendChild(item.el); });
      }

      currentColor() {
        if (!this.colorPos) return null;
        var checked = this.card && this.card.querySelector('input[name$="-swatch"]:checked');
        if (checked && typeof checked.value === 'string' && checked.value.length) return checked.value;
        return this.defaultColor || null;
      }

      colorOfVariantId(id) {
        if (!this.colorPos) return null;
        for (var i = 0; i < this.variants.length; i++) {
          if (String(this.variants[i].id) === String(id)) return this.variants[i].o[this.colorPos - 1];
        }
        return null;
      }

      onVariantUpdate(event) {
        var id = event && event.detail && event.detail.resource && event.detail.resource.id;
        var color = id ? this.colorOfVariantId(id) : this.currentColor();
        this.refresh(color);
      }

      onSwatchChange(event) {
        var t = event.target;
        if (!t || !t.name || t.name.indexOf('-swatch') === -1) return;
        var self = this;
        setTimeout(function () { self.refresh(self.currentColor()); }, 0);
      }

      refresh(color) {
        if (!this.list) return;
        var buttons = this.list.querySelectorAll('.card-size-picker__btn');
        for (var b = 0; b < buttons.length; b++) {
          var btn = buttons[b];
          var size = btn.getAttribute('data-size');
          var match = null;
          for (var i = 0; i < this.variants.length; i++) {
            var v = this.variants[i];
            if (v.o[this.sizePos - 1] !== size) continue;
            if (this.colorPos && color != null && v.o[this.colorPos - 1] !== color) continue;
            match = v;
            break;
          }
          if (btn.getAttribute('data-state') === 'loading') continue;
          if (match) {
            btn.setAttribute('data-variant-id', match.id);
            var avail = match.a === true;
            btn.disabled = !avail;
            btn.setAttribute('aria-disabled', avail ? 'false' : 'true');
          } else {
            btn.removeAttribute('data-variant-id');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          }
        }
      }

      onClick(event) {
        var btn = event.target.closest('.card-size-picker__btn');
        if (!btn || btn.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        this.addToCart(btn, variantId);
      }

      addToCart(btn, variantId) {
        var self = this;
        btn.setAttribute('data-state', 'loading');

        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          var sid = el.getAttribute('data-section-id');
          if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
        });

        var form = new FormData();
        form.append('id', variantId);
        form.append('quantity', '1');
        if (sectionIds.length) form.append('sections', sectionIds.join(','));

        var routes = (window.Theme && window.Theme.routes) || {};
        var addUrl = routes.cart_add_url || '/cart/add';
        var cartUrl = (routes.cart_url || '/cart') + '.js';

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: form
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              throw new Error((result.data && (result.data.description || result.data.message)) || 'add failed');
            }
            var sections = result.data.sections;
            return fetch(cartUrl)
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart || {},
                    sourceId: 'card-size-picker',
                    data: {
                      source: 'card-size-picker',
                      itemCount: cart ? cart.item_count : undefined,
                      productId: self.dataset.productId,
                      sections: sections
                    }
                  }
                }));
                var drawer = document.querySelector('cart-drawer-component');
                if (drawer && typeof drawer.open === 'function') drawer.open();
                btn.setAttribute('data-state', 'added');
                if (self.live) self.live.textContent = (window.Theme && window.Theme.translations && window.Theme.translations.added) || 'נוסף לסל';
                setTimeout(function () { if (btn.getAttribute('data-state') === 'added') btn.removeAttribute('data-state'); }, 1500);
              });
          })
          .catch(function (err) {
            if (window.console) console.error('[card-size-picker]', err);
            btn.removeAttribute('data-state');
            if (self.live) self.live.textContent = 'לא ניתן להוסיף לסל כעת';
          });
      }
    }

    customElements.define('card-size-picker', CardSizePicker);
  })();
  } catch(e) { console.error(e); }
})();

})();
